import { styled as e } from "styled-components";
//#region src/components/Composer/components/ComposerField.styled.ts
var t = e.textarea`
    flex: 1;
    min-width: 0;
    border: none;
    outline: none;
    background: transparent;
    resize: none;
    overflow-y: auto;
    max-height: 120px;
    padding: ${({ theme: e }) => e.spacing(1, 0)};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: 16.5px;
    line-height: 1.4;
    color: ${({ theme: e }) => e.colors.foreground};

    &::placeholder {
        color: ${({ theme: e }) => e.colors.mutedForeground};
    }
`;
//#endregion
export { t as Field };
